import React, { useEffect, useState } from 'react';
import Title from '../../../components/title';
import TableComponent from '../../../components/table';
import { parserSerialList } from '../../../utils/parsers/serials';
import Spinner from '../../../components/spinner';
import { Pagination } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getAllDetailSerials } from '../../../redux/actions/serial';
import { useParams } from 'react-router-dom';

const SerialsDetail = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { id: serialId } = useParams();
  const pageSize = 10;
  const dispatch = useDispatch();
  const { serialDetails, isLoading } = useSelector((state) => state.serial);

  const columsDetailSerial = [
    // {
    //   title: 'Serial',
    //   dataIndex: 'serial',
    //   key: 'serial',
    // },
    {
      title: 'Enviado (request)',
      dataIndex: 'request',
      key: 'request',
    },
    {
      title: 'Recibido (response)',
      dataIndex: 'response',
      key: 'response',
    },
    {
      title: 'Fecha',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
  ];

  useEffect(() => {
  dispatch(getAllDetailSerials(serialId, currentPage, pageSize));
}, [dispatch, serialId, currentPage, pageSize]);

    const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className='container-page__box'>
      <div
        className='container-page__header'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '24px 28px',
        }}
      >
        <div className='container-page__header'>
          <Title text='Detalle serial' />
        </div>
      </div>

      <div className='container-page__table' style={{ padding: '0 28px' }}>
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <TableComponent
              columns={columsDetailSerial}
              dataSource={parserSerialList(serialDetails?.data?.data)}
              actions={false}
            />
            <div className='container-page__pagination'>
              <Pagination
                current={currentPage}
                onChange={handlePageChange}
                total={serialDetails?.data?.total}
                pageSize={pageSize}
                showSizeChanger={false}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SerialsDetail;